export default __webpack_public_path__ + "static/media/logo.42c7a36d.svg";